module.exports = __webpack_public_path__ + "img/8ee16eb3276ddbb63f361b4acc2cd1f6_副本.4f0deb59.jpg";